<template>
  <CommonQuery
    :formTitle="textObj.formTitle"
    :infoArray="infoArray"
    :isLoading="isLoading"
    :hint="textObj.hint"
  >
    <template v-slot:result-content>
      <ResultContent
        :backgroundColor="bgColor"
        :resultArray="resultArray"
      />
    </template>
  </CommonQuery>
</template>

<script>
import CommonQuery from '../pc/message/message-elements/common-query/index.vue'
import ResultContent from '../pc/message/message-elements/common-query/result-content.vue'

export default {
  components: { CommonQuery, ResultContent },
  data() {
    return {
      textObj: {
        formTitle: '购车订单进展查询',
        hint: '订单具体进展客服无法查询，如有需求请您拨打购车经销商电话或者和销售顾问联系请您拨打购车经销商电话或者和销售顾问联系咨询~'
      },
      isLoading: false,
      bgColor: '#FFF7E6',
      infoArray: [
        { label: '手机号', value: '' },
        { label: '订单编号', value: '' }
      ],
      resultArray: [
        { label: '订单状态', value: '', bold: true },
        { label: '经销商名称', value: '' },
        { label: '经销商电话', value: '' }
      ]
    }
  },
  async mounted() {
    this.isLoading = true
    try {
      this.infoArray = [
        { label: '手机号', value: '13899998888' },
        { label: '订单编号', value: '7017811467171458' }
      ]
      this.resultArray = [
        { label: '订单状态', value: '交付准备中', style: { fontWeight: 'bold', color: 'red' } },
        { label: '经销商名称', value: '深圳浩迪益田汽车销售有限公司' },
        { label: '经销商电话', render: this.renderPhoneComponent, onClick: this.handlePhoneClick, value: '(0755) 8992 8088' }
      ]
    } catch (error) {
      console.error('加载数据失败:', error)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    renderPhoneComponent() {
      return '<span style="color: #2290FD; font-size: 12px; line-height: 18px; cursor: pointer; text-decoration: underline;">(0755) 8992 8088</span>'
    },
    handlePhoneClick(phoneNumber) {
      console.log('点击了经销商电话:', phoneNumber)
      alert(`拨打经销商电话: ${phoneNumber}`)
    }
  }
}
</script>

<style scoped lang="less">
.clickable-phone {
  color: #2290FD;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  text-decoration: underline;
}
.result-value-bold{
  font-weight: bold;
  color:red
}
</style>
